export function initMailerLite() {
	const forms = Array.from(
		new Set([
			...document.querySelectorAll('[data-ml-form]'),
			...document.querySelectorAll('form#project-ml-form'),
			...document.querySelectorAll('form[action*="assets.mailerlite.com/jsonp/"]'),
		])
	);
	console.log(`[ML:DEBUG] Found ${forms.length} MailerLite forms`);

	if (!forms.length) {
		console.warn('[ML] No MailerLite forms found.');
		return;
	}

	const isLocal =
		location.hostname.includes('localhost') ||
		location.hostname.includes('127.') ||
		location.hostname.includes('.local');

	forms.forEach((form, index) => {
		console.groupCollapsed(`[ML:DEBUG] Initializing form #${index}`);
		form.setAttribute('novalidate', 'novalidate');

		const submitBtn =
			form.querySelector('[data-ml-submit]') ||
			form.querySelector('#ml-submit-btn') ||
			form.querySelector('button[type="submit"]');

		const submitText = form.querySelector('.ml-submit-text');

		let successEl =
			form.querySelector('.ml-form-successBody, #ml-success') ||
			form.parentElement?.querySelector('.ml-form-successBody, #ml-success') ||
			form.closest('.ml-form-embedWrapper, .ml-form-embedContainer, section, div')?.querySelector('.ml-form-successBody, #ml-success') ||
			document.getElementById('ml-success');

		const msgEl =
			form.querySelector('.ml-message, #ml-message') ||
			(() => {
				const div = document.createElement('div');
				div.className = 'ml-message mt-2 mb-6 p-3 rounded text-sm text-center sm:text-left hidden';
				form.appendChild(div);
				return div;
			})();

		const emailInput =
			form.querySelector('input[name="fields[email]"]') || form.querySelector('#ml-email');

		const emailWrapper =
			form.querySelector('.ml-email-wrapper') || emailInput?.closest('div');

		let overlay =
			form.querySelector('.ml-overlay, #ml-overlay') ||
			form.closest('.relative')?.querySelector('.ml-overlay, #ml-overlay') ||
			document.getElementById('ml-overlay');

		const action = form.getAttribute('action') || '';
		if (!action) {
			console.warn('[ML] Form action missing:', form);
			return;
		}

		console.log('[ML:DEBUG] successEl:', successEl);
		console.log('[ML:DEBUG] msgEl:', msgEl);
		console.log('[ML:DEBUG] emailInput:', emailInput);
		console.log('[ML:DEBUG] overlay:', overlay);
		console.groupEnd();

		const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(String(email).trim());
		const showFieldError = (text) => {
			if (!emailWrapper) return;
			const existing = form.querySelector('#ml-email-error');
			if (existing) existing.remove();
			const err = document.createElement('p');
			err.id = 'ml-email-error';
			err.className = 'mt-0 mb-2 text-sm text-red-600 text-center sm:text-left';
			err.role = 'alert';
			err.textContent = text;
			emailWrapper.insertAdjacentElement('afterend', err);
		};
		const clearFieldError = () => {
			const existing = form.querySelector('#ml-email-error');
			if (existing) existing.remove();
		};
		const showMessage = (type, text) => {
			if (!msgEl) return;
			msgEl.innerHTML = text || '';
			msgEl.className =
				'ml-message mt-6 mb-6 p-3 rounded text-sm text-center sm:text-left transition-colors';
			msgEl.classList.remove('hidden');
			if (type === 'success') {
				msgEl.classList.add('bg-green-50', 'border', 'border-green-200', 'text-green-800');
			} else if (type === 'error') {
				msgEl.classList.add('bg-red-50', 'border', 'border-red-200', 'text-red-600');
			} else {
				msgEl.classList.add('bg-yellow-50', 'border', 'border-yellow-200', 'text-yellow-800');
			}
		};
		const clearMessage = () => {
			if (!msgEl) return;
			msgEl.innerHTML = '';
			msgEl.classList.add('hidden');
		};
		const disableUI = () => {
			submitBtn?.setAttribute('disabled', 'true');
			submitText?.classList.add('opacity-0');
			if (overlay) {
				console.log('[ML:DEBUG] Showing overlay');
				overlay.classList.remove('hidden');
				overlay.setAttribute('aria-hidden', 'false');
				overlay.setAttribute('aria-busy', 'true');
			}
		};
		const enableUI = () => {
			submitBtn?.removeAttribute('disabled');
			submitText?.classList.remove('opacity-0');
			if (overlay) {
				console.log('[ML:DEBUG] Hiding overlay');
				overlay.classList.add('hidden');
				overlay.setAttribute('aria-hidden', 'true');
				overlay.setAttribute('aria-busy', 'false');
			}
		};
		const isGdprOk = () => {
			const checkboxes = form.querySelectorAll('input[name="gdpr[]"]');
			return Array.from(checkboxes).some((cb) => cb.checked);
		};
		const extractMessage = (resp) => {
			if (!resp) return '';
			if (typeof resp === 'string') return resp;
			return (
				resp.message ||
				resp.msg ||
				resp.data ||
				resp.description ||
				resp.error ||
				resp.response ||
				''
			);
		};
		const detectAlreadySubscribed = (resp) => {
			const msg = extractMessage(resp);
			return /already|exists|duplicate|subscribed|present/i.test(msg);
		};

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			e.stopPropagation();
			clearMessage();
			clearFieldError();

			console.log(`[ML:DEBUG] Form #${index} submitted`);

			const email = emailInput?.value?.trim() || '';
			let hasError = false;
			if (!isValidEmail(email)) {
				console.warn('[ML:DEBUG] Invalid email');
				showFieldError('Please enter a valid email address.');
				hasError = true;
			}
			if (!isGdprOk()) {
				console.warn('[ML:DEBUG] GDPR not accepted');
				showMessage('error', 'Checking the consent to receive the newsletter is required.');
				hasError = true;
			}
			if (hasError) return;

			disableUI();
			console.log(`[ML:DEBUG] Sending to MailerLite:`, email);

			const fd = new FormData(form);
			const params = new URLSearchParams(fd);
			const callbackName = `ml_jsonp_cb_${index}_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

			let src = action;
			if (!src.endsWith('?')) {
				src += src.includes('?') ? '&' : '?';
			}
			src += params.toString();
			if (!src.includes('callback=')) {
				src += `&callback=${callbackName}`;
			}

			console.log('[ML:DEBUG] JSONP src:', src);

			const script = document.createElement('script');
			script.src = src;
			script.async = true;

			let finished = false;

			const timeout = setTimeout(() => {
				if (finished) return;
				finished = true;
				if (isLocal) {
					console.warn('[ML:DEBUG] Local mode — simulating success ✅');
					showMessage('success', 'Simulated local success');
					enableUI();
					successEl?.classList.remove('hidden');
					successEl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
				} else {
					console.error('[ML] JSONP request timed out.');
					showMessage('error', 'Request timed out. Please try again.');
					enableUI();
				}
				try {
					document.head.removeChild(script);
				} catch {}
				delete window[callbackName];
			}, isLocal ? 2000 : 10000);

			window[callbackName] = (resp) => {
				console.log(`[ML:DEBUG] Callback ${callbackName} fired`, resp);
				if (finished) return;
				finished = true;
				clearTimeout(timeout);

				try {
					const msg = extractMessage(resp).toLowerCase();
					const isSuccess =
						resp?.result === 'success' ||
						resp?.status === 'success' ||
						resp?.success === true ||
						msg.includes('success');
					const already = detectAlreadySubscribed(resp);

					console.log(`[ML:DEBUG] isSuccess: ${isSuccess}, already: ${already}`);

					if (isSuccess && !already) {
						console.log('[ML:DEBUG] Success branch reached');
						const hideSelectors = [
							'.ml-email-wrapper',
							'.ml-form-embedPermissions',
							'.ml-message',
							'.ml-submit-wrapper',
							'input[name="fields[email]"]',
							'.relative.w-full.sm\\:w-auto',
						];
						hideSelectors.forEach((sel) => {
							form.querySelectorAll(sel).forEach((el) => el.classList.add('hidden'));
						});

						if (submitBtn) submitBtn.style.display = 'none';

						requestAnimationFrame(() => {
							if (successEl) {
								console.log('[ML:DEBUG] Showing successEl:', successEl);
								successEl.classList.remove('hidden');
								successEl.style.display = 'block';
								successEl.setAttribute('aria-hidden', 'false');
								successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
							} else {
								console.warn('[ML:DEBUG] Success element not found near form', form);
							}
						});

						clearMessage();
						enableUI();
					} else if (already) {
						console.warn('[ML:DEBUG] Already subscribed');
						showMessage('info', 'This email address is already subscribed. Check your inbox!');
						enableUI();
					} else {
						console.error('[ML:DEBUG] Subscription failed:', extractMessage(resp));
						showMessage('error', extractMessage(resp) || 'Subscription failed.');
						enableUI();
					}
				} catch (err) {
					console.error('[ML:DEBUG] Error processing JSONP response:', err);
					showMessage('error', 'Unexpected error processing response.');
					enableUI();
				} finally {
					try {
						document.head.removeChild(script);
					} catch {}
					delete window[callbackName];
				}
			};

			script.onerror = (err) => {
				if (finished) return;
				finished = true;
				clearTimeout(timeout);
				if (isLocal) {
					console.warn('[ML:DEBUG] Local mode — simulating success after error');
					window[callbackName]({ result: 'success', message: 'Local simulated success' });
					return;
				}
				console.error('[ML:DEBUG] JSONP script load error', err);
				showMessage('error', 'Failed to load MailerLite service. Please disable adblockers or try later.');
				enableUI();
				try {
					document.head.removeChild(script);
				} catch {}
				delete window[callbackName];
			};

			console.log('[ML:DEBUG] Injecting JSONP script...');
			document.head.appendChild(script);
		});
	});

	console.info('[ML] MailerLite initialized');

	document.addEventListener('click', (e) => {
		const btn = e.target.closest('[data-modal-hide="ml-form-modal"]');
		if (!btn) return;

		const modal = document.getElementById('ml-form-modal');
		if (!modal) return;

		// Uswanie focusa z aktywnych elementów w modalu
		const active = modal.querySelector(':focus');
		if (active) {
			active.blur();
			console.log('[ML:A11Y] Blurred focused element before hiding modal');
		}

		// Dodanie "hidden" po czasie
		setTimeout(() => {
			modal.setAttribute('aria-hidden', 'true');
		}, 200);
	});
}
